import React from 'react';
import sessionStore from 'utils/sessionStore';

const { createContext, useContext, useState, useEffect } = React;

export const GlobalConfigContext = createContext({});
GlobalConfigContext.displayName = 'GlobalConfig';

export const GlobalConfigProvider = (props) => {
  const { children, fonts, UA } = props;

  const isMobile = UA ? UA.device.type === 'mobile' : false;
  const isIOS = UA ? UA.os.name === 'iOS' : false;
  const isSafari = UA
    ? UA.browser.name === 'Safari' || UA.browser.name === 'Mobile Safari'
    : false;

  const [showAppDownloadModal, setShowAppDownloadModal] = useState(false);
  const [showAppDownloadBanner, setShowAppDownloadBanner] = useState(false);

  const device = {
    isMobile,
    isIOS,
    isSafari,
  };

  const [showMobileMoreModal, setShowMobileMoreModal] = useState(false);

  const [menubarHeight, setMenubarHeight] = useState(0);

  useEffect(() => {
    const showAppDownloadPopup = sessionStore.getShowAppDownloadPopup();
    if (showAppDownloadPopup) {
      setShowAppDownloadModal(true);
    }
    const showAppDownloadBanner = sessionStore.getShowAppDownloadBanner();
    if (showAppDownloadBanner) {
      setShowAppDownloadBanner(true);
    }
  }, []);

  return (
    <GlobalConfigContext.Provider
      value={{
        fonts,
        device,
        showMobileMoreModal,
        setShowMobileMoreModal,
        showAppDownloadModal,
        setShowAppDownloadModal,
        menubarHeight,
        setMenubarHeight,
        showAppDownloadBanner,
        setShowAppDownloadBanner,
      }}
    >
      {children}
    </GlobalConfigContext.Provider>
  );
};

export const useGlobalConfig = () => {
  return useContext(GlobalConfigContext);
};
